
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Der Cluster-Kopfschmerz ist selten. Weniger als ein Prozent der Bevölkerung
erleben innerhalb eines Jahres eine Attacke. Sie können in jedem Lebensalter
auftreten, beginnen aber am häufigsten im Alter von 20 bis 40 Jahren. Die
Schmerzattacken können Betroffene ein Leben lang begleiten. Allerdings lässt der
Schmerz bei einigen im höheren Alter nach. Männer sind etwa dreimal so häufig
betroffen wie Frauen. Frauen dagegen sind bei der Hemikranie in der Überzahl.
Dieser sehr heftige, attackenartige einseitige Kopfschmerz spricht – im
Gegensatz zum Cluster-Kopfschmerz – aber auf das Schmerzmittel Indometacin an.
Bei manchen Betroffenen wird die Hemikranie durch Alkoholgenuss oder auch durch
Kopfdrehungen ausgelöst.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;